import React from 'react';
import './index.scss';

interface StandaloneDatePickerProps {
  name: string;
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  minDate?: string;
  maxDate?: string;
}

export const StandaloneDatePicker: React.FC<StandaloneDatePickerProps> = ({
  name,
  id,
  label,
  value,
  onChange,
  placeholder = 'Select Date',
  required = false,
  hasError = false,
  disabled = false,
  minDate,
  maxDate
}) => {
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`standalone-date-picker ${hasError ? 'error' : ''}`}>
      <label className="date-picker-label" htmlFor={id || name}>
        {label}
        {required && <span className="required-indicator">*</span>}
      </label>
      <div className="date-input-wrapper">
        <input
          type="date"
          name={name}
          id={id || name}
          value={value}
          onChange={handleDateChange}
          className={`date-input ${hasError ? 'error' : ''}`}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          min={minDate}
          max={maxDate}
        />
        <div className="date-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
